export var ELoadingSize;
(function (ELoadingSize) {
    ELoadingSize[ELoadingSize["Small"] = 6] = "Small";
    ELoadingSize[ELoadingSize["Medium"] = 12] = "Medium";
    ELoadingSize[ELoadingSize["Large"] = 18] = "Large";
})(ELoadingSize || (ELoadingSize = {}));
